import firebase from '../firebase/firebase';

// export const registerServiceWorker = () => async dispatch => {
//     const messaging = firebase.messaging();
//     const database  = firebase.database();
//     const pushBtn   = document.getElementById('push-button');

//     let userToken    = null;
//     let isSubscribed = false;

//     window.addEventListener('load', () => {
//         if ('serviceWorker' in navigator) {

//             navigator.serviceWorker.register('../../../firebase-messaging-sw.js')
//                 .then(registration => {
//                     messaging.useServiceWorker(registration);
//                     // initializePush()
//                 })
//                 .catch(err => {
//                     // console.log('Service Worker Error', err)
//                 })

//         } else {
//             // pushBtn.textContent = 'Push not supported.'
//             // console.log('SERVICE WORKER NOT SUPPORTED');
//         }
//     }) 
// }


// WEBPACK FOOTER //
// ./src/js/actions/service-worker-actions.js